/**
 * =====================================================================
 * SINGLE SOURCE OF TRUTH: GLOBAL THEME & COLOR CONFIGURATION
 * =====================================================================
 * Edit ANY color in this one file to change it across the ENTIRE app!
 * Updates will automatically propagate to:
 * - Tailwind CSS classes (`bg-accent-yellow`, `text-accent-yellow`, etc.)
 * - Action buttons (`New Invoice`, `Search`, `Add`, `.btn-primary`)
 * - Active pagination and sidebar navigation pills
 * - Light and Dark theme surfaces, cards, and borders
 * - Financial status badges (Paid, Open, Overdue, etc.)
 */

export const themeColors = {
  // --- PRIMARY ACCENT PALETTE (Buttons, Active Pills, Highlights) ---
  accent: {
    primary: 'oklch(83.7% 0.128 66.29)',       // Requested exact OKLCH accent color
    primaryHover: 'oklch(78.5% 0.135 66.29)',  // Smooth hover state in OKLCH
    primaryText: '#0F172A',                    // Dark slate text for optimal contrast
    primaryBorder: 'oklch(78.5% 0.135 66.29 / 0.5)', // Subtle matching border
    subtle: 'oklch(83.7% 0.128 66.29 / 0.15)', // Soft background tint
  },

  // --- LIGHT THEME NEUTRALS ---
  light: {
    bg: '#F1F5F9',            // Viewport background
    surface: '#FFFFFF',       // Top navbar & sidebar background
    card: '#FFFFFF',          // Card/table container background
    border: '#E2E8F0',        // Border lines
    text: '#0F172A',          // Main heading and body text
    textMuted: '#64748B',     // Subtitles, table headers, placeholders
  },

  // --- DARK THEME NEUTRALS ---
  dark: {
    bg: '#000000',            // Dark viewport background
    surface: '#111827',       // Dark navbar & sidebar
    card: '#1F2937',          // Dark card/table container
    border: '#374151',        // Dark borders
    text: '#F3F4F6',          // Dark mode main text
    textMuted: '#9CA3AF',     // Dark mode muted text
  },

  // --- INTERNATIONALLY RECOGNIZED FINANCIAL STATUS COLORS ---
  status: {
    paid: '#10B981',          // Emerald Green
    open: '#0284C7',          // Sky Blue
    posted: '#0284C7',        // Sky Blue
    approved: '#0284C7',      // Sky Blue
    partial: '#D97706',       // Amber Orange
    overdue: '#E11D48',       // Crimson Rose
    cancelled: '#71717A',     // Zinc Gray
    draft: '#64748B',         // Slate Gray
  },
};

export default themeColors;
